import Bar from "../Bar";
import SpinButton from "../buttons/SpinButton";
import StakeButton from "../buttons/StakeButton";
import AutoplayButton from "../buttons/AutoplayButton";
import TurboButton from "../buttons/TurboButton";
import classes from "../../styles/Bar.module.css";
import { getClasses } from "../../utils";
import BuyBonusButton from "../buttons/BuyBonusButton";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";

const ButtonsBar: React.FC = () => {
  const buttonData: any = useAppSelector(selectButton.bind(null, "spin"));
  const { hidden } = buttonData;
  const buttons = useAppSelector((state) => state.buttons);
  const left = buttons.buyBonus.available && buttons.stake.available;
  const right = buttons.autoplay.available && buttons.turbo.available;
  // if there is two buttons on one/or both/ of the sides the buttons
  // are aligned to the bottom, otherwise they are centered
  const alignment = left || right ? "align end" : "align center";
  const extraClass = hidden ? "hidden-buttons" : "";

  return (
    <Bar
      className={getClasses(
        classes,
        "portrait-buttons middle align center",
        extraClass
      )}
    >
      <Bar className={alignment}>
        <div className={getClasses(classes, "buttons-section")}>
          <BuyBonusButton className="portrait circle left" />
          <StakeButton className="portrait circle left" />
        </div>
        <SpinButton className="portrait spin" />
        <div className={getClasses(classes, "buttons-section")}>
          <TurboButton className="portrait circle right" />
          <AutoplayButton className="portrait circle right" />
        </div>
      </Bar>
    </Bar>
  );
};

export default ButtonsBar;
